export const PULSATION_STYLE = { boxShadow: '0px 0px 20px 0px #E78521 inset' } as const;
export const COMPONENT_ICON_OPTS = { disableClickPropagation: true } as const;
